// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__35xis","pagination":"style_pagination__2nprV","createButton":"style_createButton__1lrF7","wrapList":"style_wrapList__31kTC"};